import request from '../../../utils/request'

// 根据审核状态统计企业兑付记录
export function getExchangeList(params) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/countBySpzt',
    method: 'get',
    params: params,
    headers: {
      isToken: true
    }
  })
}

// 分页查询兑付记录
export function getPageExchangeList(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/pageTab',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查看兑付详情
export function getExchangeDetail(dfId) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/getDfFormData',
    method: 'get',
    params: dfId,
    headers: {
      isToken: true
    }
  })
}

// 新增兑付
export function addExchange(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/completeDf',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 上传兑付材料
export function uploadMaterials(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/uploadDfFile',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 兑付表单pdf下载
export function pdfUpload(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factDfsqxx/printDfPdf?' + params
}

// 兑付申请书pdf预览控件页面
export function printPdfView(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factDfsqxx/previewFile?' + params
}

// 查询所有服务机构
export function getListAll(params) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/listAll',
    method: 'get',
    params,
    headers: {
      isToken: true
    }
  })
}

// 查询服务机构下所有服务
export function getListByJgid(jgid) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/listByJgid',
    method: 'get',
    params: jgid,
    headers: {
      isToken: true
    }
  })
}

// 查询字典信息
export function getDictionaryList(parentCode) {
  return request({
    url: '/sc/system/api/sysDictionary/getDictList',
    method: 'get',
    params: parentCode,
    headers: {
      isToken: true
    }
  })
}

// 递归查询字典（如：查询湖北省三级区划）
export function recursionDictData(params) {
  return request({
    url: '/sc/system/api/sysDictionary/recursionDictData',
    method: 'get',
    headers: {
      isToken: true
    },
    params
  })
}

// 查询企业当前领券信息
export function getCouponList(data) {
  return request({
    url: '/sc/ticketMain/api/factQylq/listByQy',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 删除附件材料
export function removeFileRecord(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/removeDfFile',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 下载附件材料
export function downloadFileRecord(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factDfsqxx/downloadFile?' + params
}

// 查看兑付详情所有的附件
export function getDfFileList(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/getDfFileList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 分页查询兑付过程信息
export function getPageExchangeProcessList(data) {
  return request({
    url: '/sc/ticketMain/api/factDfgcxx/page',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 兑付完成之后提交评价
export function submitEvaluation(data) {
  return request({
    url: '/sc/ticketMain/api/factDfpjb/estimate',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 查询当前兑付是否评价，如果已经评价，则会返回信息
export function queryEvaluation(data) {
  return request({
    url: '/sc/ticketMain/api/factDfpjb/getByDfid',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}


// 完善兑付表单信息
export function updateDfForm(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/updateDfForm',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}


// 完善兑付表单信息
export function updateBccl(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/updateBccl',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 判断当前用户，已申报的办件是否需要完善字段信息
export function getDfListParams(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/validatePerfectInformation',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 判断当前用户，已申报的办件是否需要完善近三年财务文件
export function validateBccl(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/validateBccl',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 下载收据模板pdf方法
 export function downloadDfpjPdf(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factDfsqxx/printDfpjPdf?' + params
}

// 查询企业的最终核准兑付金额
 export function getFinalAmount(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/queryQyEndHzdfje',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

